// extracted by mini-css-extract-plugin
module.exports = {"formDataContainer":"DatiAziendali_formDataContainer__2WbDb","formLabel":"DatiAziendali_formLabel__3LweU","profile_title":"DatiAziendali_profile_title__2T3bI"};